// extracted by mini-css-extract-plugin
module.exports = {"horizontalLine":"ACCategory_horizontalLine__3zNJC","container":"ACCategory_container__2t_b9","content":"ACCategory_content__7Feh2","standardText":"ACCategory_standardText__2AuDh"};